export default __webpack_public_path__ + "static/dot-net-development-company-peerbits-ae27d66046863d96c2de1d230eb876a0.png";